import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import type {MainMenuDomainModel} from "./main-menu.domain-model";
import {BaseUrlModel} from "../../../../infrastructure/models/link/base-url-model";
import {BaseLinkModelSettings} from "../../../../infrastructure/models/link/base-link-model-settings";
import {BaseNavigationModel} from "../../../../infrastructure/models/link/base-navigation-model";
import type {LanguageViewModel} from "../../../locale/models/language/language.view-model";

export class MainMenuViewModel extends BaseViewModel {
  domainModel: MainMenuDomainModel

  constructor(domainModel: MainMenuDomainModel, language: LanguageViewModel) {
    super(domainModel);

    this.language = language;
    this.label = domainModel.label;
    this.url = domainModel.url;
  }

  get linkModel(): BaseUrlModel {
    const setting: BaseLinkModelSettings = new BaseLinkModelSettings(false, false, true, false);

    return new BaseNavigationModel(this.url, true, setting);
  }
}
